
<div class="file-add-modal">
    <div class="file-header">
        <div class="f-16 f-w-600"> Attached Files </div>
        <a href="javascript:" class="text-muted" mat-dialog-close>
            <i class="ti ti-x f-20"></i>
        </a>
    </div>
    <div class="file-body">

        <div class="row">
            @for (task of attachedFiles; track task) {
              <div class="col-md-12 col-xl-6">
                <app-card [showHeader]="false">
                  <div class="flex">
                    <div class="flex-shrink-0 m-r-15">
                      <svg class="wid-40 hei-40 text-warning-500">
                        <use xlink:href="assets/fonts/custom-icon.svg#custom-folder-open"></use>
                      </svg>
                    </div>
                    <div class="flex-grow-1 m-r-15">
                      <div class="m-b-8 f-16 f-w-600 grid"
                        ><span class="text-truncate w-100">{{ task.name }}</span></div
                      >
                      <p class="m-b-0"
                        ><small>{{ task.ext }}</small></p
                      >
                    </div>
                   <!--  <a href="javascript:" class="flex align-item-center text-muted" [matMenuTriggerFor]="menu">
                      <i class="material-icons-two-tone f-18">more_vert</i>
                    </a> -->
                 
                  </div>
                </app-card>
              </div>
            }
          </div>

    </div>
    <div class="file-footer">
        <div class="text-end">
            <button mat-flat-button color="accent" class="m-r-10" mat-dialog-close>Close</button>
        </div>
    </div>
</div>